<template>
    <div class="check-rebate-manage" style="margin-bottom: 20px;">
        <!-- Page Header -->
        <div class="page-header">
            <h2>返点管理</h2>
            <p>管理和查看返点信息，支持按类型筛选和数据统计</p>
        </div>

        <!-- Current Info -->
        <div class="info-selector">
            <span>当前角色：</span>
            <el-tag type="primary" size="large">
                <el-icon><User /></el-icon>
                {{ curRole === 'admin' ? '管理员' : curRole === 'sales' ? '销售' : '代理商' }}
            </el-tag>
            <el-button type="primary" @click="search" :loading="loading" style="margin-left: 16px;">
                刷新数据
            </el-button>
        </div>

        <!-- Main Tabs -->
        <el-tabs v-model="activeTab" type="card" class="rebate-tabs" style="margin-bottom: 20px;">
            <!-- Rebate Data Tab -->
            <el-tab-pane label="返点数据" name="rebateData">
                <div class="tab-content">
                    <!-- Toolbar with Filters -->
                    <div class="toolbar">
                        <div class="filter-section">
                                <el-form :inline="true" :model="formInline" class="filter-form" label-width="80px">


                                <!-- Date for All Roles -->
                                <el-form-item label="选择月份">
                                    <el-date-picker
                                        @change="search"
                                        format="YYYY-MM"
                                        value-format="YYYYMM"
                                        v-model="formInline.month"
                                        type="month"
                                        placeholder="选择月份">
                                    </el-date-picker>
                                </el-form-item>

                                <!-- Region -->
                                <el-form-item label="地区">
                                    <el-select v-model="formInline.region" clearable @change="search" placeholder="请选择地区">
                                        <el-option
                                            v-for="(item,index) in regionList"
                                            :key="index"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <!-- Payers -->
                                <el-form-item label="Payers">
                                    <el-select v-model="formInline.payer_id" clearable filterable @change="search" placeholder="请选择Payers">
                                        <el-option
                                            v-for="(item,index) in payersList"
                                            :key="index"
                                            :label="item.name+'('+item.payer_id+')'"
                                            :value="item.payer_id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <!-- Sales -->
                                <el-form-item label="销售" v-if="curRole=='admin'">
                                    <el-select clearable filterable v-model.trim="formInline.sales" placeholder="请选择销售" @change="search">
                                        <el-option
                                            v-for="item in salesList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.name">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <!-- Partners -->
                                <el-form-item label="合作伙伴" v-if="curRole=='admin'||curRole=='sales'">
                                    <el-select clearable filterable v-model.trim="formInline.agent_id" placeholder="请选择合作伙伴" @change="search">
                                        <el-option
                                            v-for="item in agentsList"
                                            :key="item.agent_id"
                                            :label="item.company"
                                            :value="item.agent_id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <!-- Customer -->
                                <el-form-item label="客户">
                                    <el-select v-model="formInline.customer" clearable filterable @change="search" placeholder="请选择客户">
                                        <el-option
                                            v-for="(item,index) in customersList"
                                            :key="index"
                                            :label="item.company"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <!-- LinkId -->
                                <el-form-item label="LinkId">
                                    <el-input
                                        v-model="formInline.link_id"
                                        clearable
                                        @change="search"
                                        placeholder="请输入LinkId">
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>

                    <!-- Statistics Cards -->
                    <div class="stats-section" style="margin-bottom: 20px;">
                        <div class="stats-grid">
                            <div class="stat-card">
                                <div class="stat-icon">
                                    <el-icon><DataBoard /></el-icon>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-value">{{ pageparm.total }}</div>
                                    <div class="stat-label">总记录数</div>
                                </div>
                            </div>

                            <div class="stat-card">
                                <div class="stat-icon">
                                    <el-icon><PieChart /></el-icon>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-value">{{ averageRebate }}%</div>
                                    <div class="stat-label">平均返点</div>
                                </div>
                            </div>

                            <div class="stat-card">
                                <div class="stat-icon">
                                    <el-icon><TrendCharts /></el-icon>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-value">{{ highRebateCount }}</div>
                                    <div class="stat-label">高返点账户</div>
                                </div>
                            </div>

                            <div class="stat-card">
                                <div class="stat-icon">
                                    <el-icon><Warning /></el-icon>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-value">{{ expiringSoonCount }}</div>
                                    <div class="stat-label">即将到期</div>
                                </div>
                            </div>

                            <div class="stat-card">
                                <div class="stat-icon error-icon">
                                    <el-icon><Warning /></el-icon>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-value">{{ vapErrorCount }}</div>
                                    <div class="stat-label">返点异常</div>
                                </div>
                            </div>

                            <div class="stat-card">
                                <div class="stat-icon expired-icon">
                                    <el-icon><Warning /></el-icon>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-value">{{ expiredRebateCount }}</div>
                                    <div class="stat-label">新客返点到期</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Data Table -->
                    <el-table
                        :data="tableData"
                        v-loading="loadingPage"
                        style="width: 100%"
                        stripe
                        empty-text="暂无数据"
                        @sort-change="sortChange"
                        ref="tableref"
                        :row-class-name="tableRowClassName">>

                        <el-table-column label="LinkerId" min-width="150" show-overflow-tooltip>
                            <template #default="scope">
                                <div style="display: flex; align-items: center;">
                                    <el-icon style="margin-right: 8px; color: #409eff;"><Link /></el-icon>
                                    <span style="font-weight: 500;">{{ scope.row.linkId }}</span>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="Link名称" min-width="150" show-overflow-tooltip>
                            <template #default="scope">
                                <span style="color: #303133;">{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="PayerName" min-width="150" show-overflow-tooltip>
                            <template #default="scope">
                                <span>{{ scope.row.payer }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="账单实体" width="100" align="center">
                            <template #default="scope">
                                <el-tag type="info" size="small" plain>{{ scope.row.entity }}</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column label="VAP返点" sortable align="center" width="100" v-if="curRole=='admin'||curRole=='sales'">
                            <template #default="scope">
                                <el-tag type="success" size="small">
                                    {{ (Number(scope.row.discount1)*100).toFixed(0)+'%' }}
                                </el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column label="伙伴返点" sortable align="center" width="120">
                            <template #default="scope">
                                <div class="editable-cell" v-if="curRole=='admin'||curRole=='sales'">
                                    <el-input-number
                                        v-model="scope.row.discount2_edit"
                                        :min="0"
                                        :max="100"
                                        :precision="2"
                                        :step="0.1"
                                        size="small"
                                        style="width: 70px;"
                                        @change="updateRebate(scope.row, 'discount2')"
                                        :controls="false">
                                    </el-input-number>
                                    <span class="percent-sign">%</span>
                                </div>
                                <el-tag v-else type="warning" size="small">
                                    {{(Number(scope.row.discount2)*100).toFixed(1)+'%'}}
                                </el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column label="客户返点" align="center" width="120">
                            <template #default="scope">
                                <div class="editable-cell">
                                    <el-input-number
                                        v-model="scope.row.discount3_edit"
                                        :min="0"
                                        :max="100"
                                        :precision="2"
                                        :step="0.1"
                                        size="small"
                                        style="width: 70px;"
                                        @change="updateRebate(scope.row, 'discount3')"
                                        :controls="false">
                                    </el-input-number>
                                    <span class="percent-sign">%</span>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="截止日期" align="center" width="120" v-if="curRole!='agent'">
                            <template #default="scope">
                                <div class="editable-cell">
                                    <el-date-picker
                                        v-model="scope.row.monthEnd_edit"
                                        type="month"
                                        format="YYYY-MM"
                                        value-format="YYYYMM"
                                        size="small"
                                        style="width: 100px;"
                                        @change="updateRebate(scope.row, 'monthEnd')"
                                        placeholder="选择截止">
                                    </el-date-picker>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="VAP服务返点" align="center" width="120" v-if="curRole=='admin'||curRole=='sales'">
                            <template #default="scope">
                                <el-tag type="primary" size="small">
                                    {{ (Number(scope.row.sb_discount1 || 0)*100).toFixed(1)+'%' }}
                                </el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column label="伙伴服务返点" align="center" width="120" v-if="curRole=='admin'||curRole=='sales'">
                            <template #default="scope">
                                <div class="editable-cell">
                                    <el-input-number
                                        v-model="scope.row.sb_discount2_edit"
                                        :min="0"
                                        :max="100"
                                        :precision="2"
                                        :step="0.1"
                                        size="small"
                                        style="width: 70px;"
                                        @change="updateRebate(scope.row, 'sb_discount2')"
                                        :controls="false">
                                    </el-input-number>
                                    <span class="percent-sign">%</span>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="客户服务返点" align="center" width="120">
                            <template #default="scope">
                                <div class="editable-cell">
                                    <el-input-number
                                        v-model="scope.row.sb_discount3_edit"
                                        :min="0"
                                        :max="100"
                                        :precision="2"
                                        :step="0.1"
                                        size="small"
                                        style="width: 70px;"
                                        @change="updateRebate(scope.row, 'sb_discount3')"
                                        :controls="false">
                                    </el-input-number>
                                    <span class="percent-sign">%</span>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="状态说明" align="center" min-width="140" v-if="curRole!='agent'" sortable :sort-method="sortByStatus" show-overflow-tooltip>
                            <template #default="scope">
                                <el-tag
                                    v-if="getStatusInfo(scope.row).type === 'warning'"
                                    type="warning"
                                    size="small">
                                    {{ getStatusInfo(scope.row).text }}
                                </el-tag>
                                <el-tag
                                    v-else-if="getStatusInfo(scope.row).type === 'danger'"
                                    type="danger"
                                    size="small">
                                    {{ getStatusInfo(scope.row).text }}
                                </el-tag>
                                <el-tag
                                    v-else-if="getStatusInfo(scope.row).type === 'success'"
                                    type="success"
                                    size="small">
                                    {{ getStatusInfo(scope.row).text }}
                                </el-tag>
                                <span
                                    v-else
                                    style="color: #909399; font-size: 12px;">
                                    {{ getStatusInfo(scope.row).text }}
                                </span>
                            </template>
                        </el-table-column>

                        <el-table-column label="操作" fixed="right" width="80" align="center">
                            <template #default="scope">
                                <el-button
                                    size="small"
                                    type="primary"
                                    @click="edit(scope.row)"
                                    link
                                    style="padding: 0;">
                                    <el-icon><Edit /></el-icon>
                                    编辑
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- Pagination -->
                    <div class="pagination-container">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pageparm.page"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pageparm.limit"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="pageparm.total"
                            :background="true"
                            :hide-on-single-page="false">
                        </el-pagination>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>

        <!-- Edit Dialog -->
        <el-dialog 
            v-model="dialogVisible" 
            :close-on-click-modal="false" 
            :before-close="cancel" 
            width="600px"
            class="modern-edit-dialog">
            
            <template #header>
                <div class="dialog-header">
                    <div class="header-icon">
                        <el-icon><Edit /></el-icon>
                    </div>
                    <h3 class="dialog-title">
                        屏蔽设置配置
                        <span class="dialog-subtitle">
                            - 配置账单屏蔽选项
                        </span>
                    </h3>
                </div>
            </template>

            <div class="dialog-content">
                <el-form :inline="false" :model="formData" ref="rulesForm" label-position="right" label-width="140px" class="edit-form"> 
                    <!-- Admin/Sales View -->
                    <div v-if="curRole=='admin'||curRole=='sales'" class="form-section">
                        <h4 class="section-title">
                            <el-icon><Setting /></el-icon>
                            高级设置
                        </h4>
                        <div class="setting-info">
                            <el-alert
                                title="屏蔽设置说明"
                                description="配置不同类型费用的屏蔽选项，选择'是'将在账单中屏蔽对应费用"
                                type="info"
                                :closable="false"
                                show-icon>
                            </el-alert>
                        </div>
                        <el-row :gutter="20" style="margin-top: 20px;">
                            <el-col :span="6">
                                <el-form-item label="屏蔽Credit" prop="credit">
                                    <el-radio-group v-model="formData.credit" class="setting-radio">
                                        <el-radio :label="1">是</el-radio>
                                        <el-radio :label="0">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="屏蔽RI" prop="ri">
                                    <el-radio-group v-model="formData.ri" class="setting-radio">
                                        <el-radio :label="1">是</el-radio>
                                        <el-radio :label="0">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="屏蔽SP" prop="sp">
                                    <el-radio-group v-model="formData.sp" class="setting-radio">
                                        <el-radio :label="1">是</el-radio>
                                        <el-radio :label="0">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="屏蔽Bundle" prop="bundle">
                                    <el-radio-group v-model="formData.bundle" class="setting-radio">
                                        <el-radio :label="0">否</el-radio>
                                        <el-radio :label="1">仅屏蔽客户</el-radio>
                                        <el-radio :label="2">均屏蔽</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- Agent View - No settings available -->
                    <div v-else class="form-section">
                        <h4 class="section-title">
                            <el-icon><InfoFilled /></el-icon>
                            代理商配置
                        </h4>
                        <el-alert
                            title="配置说明"
                            description="代理商用户只能在表格中直接编辑客户返点和服务返点，此处无需额外配置"
                            type="info"
                            :closable="false"
                            show-icon>
                        </el-alert>
                    </div>
                </el-form>
            </div>

            <template #footer>
                <div class="dialog-footer">
                    <div class="footer-note">
                        <el-alert
                            title="屏蔽设置说明"
                            description="屏蔽设置修改后将立即生效，影响该账户的账单计算和显示。"
                            type="info"
                            :closable="false"
                            show-icon>
                        </el-alert>
                    </div>
                    <div class="footer-actions">
                        <el-button @click="cancel()" size="large">取消</el-button>
                        <el-button type="primary" @click="submit" size="large" :loading="submitLoading">
                            <el-icon><Check /></el-icon>
                            确定保存
                        </el-button>
                    </div>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
    import {getCheckRebateList,updateCheckRebate,getSalesList,getAgentList,getCustomerList,getPayerBasicList} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    import Pagination from "@/components/Pagination";
    export default {
        components:{
            Pagination
        },
        name:'checkRebate',
        data() {
            return {
                loadingPage:false,
                loading:false,
                submitLoading:false,
                tableHeight:500,
                activeTab: 'rebateData',
                formInline:{
                    month:0,
                    region:'',
                    sales:'',
                    agent_id:'',
                    payer_id:'',
                    link_id:'',
                    customer:'',
                    orderby:'',
                    page: 1,
                    limit: 20,
                },
                curType:'2',
                regionList:[
                    {label:'全部',value:''},
                    {label:'中国',value:'cn'},
                    {label:'Global',value:'global'}
                ],
                curYear:new Date().getFullYear(),
                curMonth:new Date().getMonth() + 1,
                curDate:'',
                salesList:[],
                agentsList:[],
                customersList:[],
                payersList:[],
                formData:{
                    discount1:'',
                    discount2:'',
                    discount3:'',
                    sb_discount2:'',
                    sb_discount3:'',
                    credit:0,
                    ri:0,
                    sp:0,
                    bundle:0,
                },
                dialogVisible:false,
                tableData:[],
                curRole:localStorage.getItem('curRole'),
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
            }
        },

        computed: {
            // 计算平均返点
            averageRebate() {
                if (this.tableData.length === 0) return '0.0';
                const total = this.tableData.reduce((sum, item) => sum + (Number(item.discount2) * 100), 0);
                return (total / this.tableData.length).toFixed(1);
            },
            
            // 计算高返点账户数量（返点>15%）
            highRebateCount() {
                return this.tableData.filter(item => Number(item.discount2) * 100 > 15).length;
            },
            
            // 计算即将到期的账户数量
            expiringSoonCount() {
                return this.tableData.filter(item => {
                    const statusInfo = this.getStatusInfo(item);
                    return statusInfo.text === '即将到期';
                }).length;
            },
            
            // 计算返点异常的账户数量
            vapErrorCount() {
                return this.tableData.filter(item => {
                    const statusInfo = this.getStatusInfo(item);
                    return statusInfo.text === '返点异常';
                }).length;
            },
            
            // 计算新客返点已到期的账户数量
            expiredRebateCount() {
                return this.tableData.filter(item => {
                    const statusInfo = this.getStatusInfo(item);
                    return statusInfo.text === '新客返点已到期';
                }).length;
            },
            
            // 返点分布数据
            rebateDistribution() {
                const ranges = [
                    { label: '0-5%', min: 0, max: 5, color: '#e74c3c', count: 0 },
                    { label: '5-10%', min: 5, max: 10, color: '#f39c12', count: 0 },
                    { label: '10-15%', min: 10, max: 15, color: '#3498db', count: 0 },
                    { label: '15%+', min: 15, max: 100, color: '#2ecc71', count: 0 }
                ];
                
                this.tableData.forEach(item => {
                    const rebate = Number(item.discount2) * 100;
                    for (let range of ranges) {
                        if (rebate >= range.min && rebate < range.max || (range.max === 100 && rebate >= range.min)) {
                            range.count++;
                            break;
                        }
                    }
                });
                
                const maxCount = Math.max(...ranges.map(r => r.count));
                return ranges.map(range => ({
                    ...range,
                    percentage: maxCount > 0 ? (range.count / maxCount) * 100 : 0
                }));
            }
        },

        methods:{
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            // 计算状态信息
            getStatusInfo(row) {
                // 1. 优先检查VAP返点异常
                const vapDiscount = Number(row.discount1 || 0) * 100;
                if (vapDiscount <= 3) {
                    return { type: 'danger', text: '返点异常', priority: 1 };
                }
                
                // 2. 检查截止日期状态
                const endDate = row.monthEnd_edit || row.monthEnd;
                
                // 如果没有设置截止日期或者是默认值
                if (!endDate || Number(endDate) === 219912) {
                    return { type: 'info', text: '未设置截止日期', priority: 5 };
                }
                
                const endDateStr = endDate.toString();
                if (endDateStr.length !== 6) {
                    return { type: 'info', text: '未设置截止日期', priority: 5 };
                }
                
                const endYear = Number(endDateStr.substring(0, 4));
                const endMonth = Number(endDateStr.substring(4, 6));
                
                // 检查是否已过期（当前日期大于截止日期）
                if (endYear < this.curYear || (endYear === this.curYear && endMonth < this.curMonth)) {
                    return { type: 'danger', text: '新客返点已到期', priority: 2 };
                } else if (endYear === this.curYear && endMonth === this.curMonth) {
                    return { type: 'warning', text: '即将到期', priority: 3 };
                } else {
                    return { type: 'success', text: '正常', priority: 6 };
                }
            },
            // 初始化编辑数据
            initEditData(data) {
                data.forEach(row => {
                    // 确保必要字段存在
                    row.payerId = row.payerId || '';
                    row.entity = row.entity || '';
                    row.month = row.month || this.formInline.month;
                    
                    // 初始化编辑字段，转换为百分比形式
                    row.discount2_edit = Number(row.discount2 || 0) * 100;
                    row.discount3_edit = Number(row.discount3 || 0) * 100;
                    row.sb_discount2_edit = Number(row.sb_discount2 || 0) * 100;
                    row.sb_discount3_edit = Number(row.sb_discount3 || 0) * 100;
                    
                    // 处理截止日期 - 修复显示问题
                    if (row.monthEnd && Number(row.monthEnd) !== 219912) {
                        // 确保monthEnd是6位数字格式 YYYYMM
                        const monthEndStr = row.monthEnd.toString();
                        if (monthEndStr.length === 6) {
                            row.monthEnd_edit = monthEndStr;
                        } else {
                            row.monthEnd_edit = '';
                        }
                    } else {
                        row.monthEnd_edit = '';
                    }
                });
                return data;
            },
            // 更新返点数据
            updateRebate(row, field) {
                // 构建完整的更新数据，包含所有必要字段
                const updateData = {
                    id: row.id,
                    linkId: row.linkId,
                    payerId: row.payerId, // 必须包含payerId
                    entity: row.entity || '',
                    month: row.month || this.formInline.month,
                    // 保持现有值
                    discount1: row.discount1 || 0,
                    discount2: row.discount2 || 0,
                    discount3: row.discount3 || 0,
                    sb_discount1: row.sb_discount1 || 0,
                    sb_discount2: row.sb_discount2 || 0,
                    sb_discount3: row.sb_discount3 || 0,
                    credit: row.credit || 0,
                    ri: row.ri || 0,
                    sp: row.sp || 0,
                    bundle: row.bundle || 0,
                    monthEnd: row.monthEnd || 219912
                };
                
                // 更新特定字段
                if (field === 'discount2') {
                    updateData.discount2 = row.discount2_edit / 100;
                    row.discount2 = updateData.discount2;
                } else if (field === 'discount3') {
                    updateData.discount3 = row.discount3_edit / 100;
                    row.discount3 = updateData.discount3;
                } else if (field === 'sb_discount2') {
                    updateData.sb_discount2 = row.sb_discount2_edit / 100;
                    row.sb_discount2 = updateData.sb_discount2;
                } else if (field === 'sb_discount3') {
                    updateData.sb_discount3 = row.sb_discount3_edit / 100;
                    row.sb_discount3 = updateData.sb_discount3;
                } else if (field === 'monthEnd') {
                    updateData.monthEnd = row.monthEnd_edit ? Number(row.monthEnd_edit) : 219912;
                    row.monthEnd = updateData.monthEnd;
                }
                
                // 调用API更新数据
                this.submitRebateUpdate(updateData);
            },
            // 提交返点更新
            submitRebateUpdate(data) {
                updateCheckRebate(data).then(res => {
                    if (res.code === 2000) {
                        this.$message.success('更新成功');
                    } else {
                        this.$message.error('更新失败：' + res.msg);
                        this.getData(); // 刷新数据
                    }
                }).catch(err => {
                    this.$message.error('更新失败：' + err.message);
                    this.getData(); // 刷新数据
                });
            },
            //获取列表
            getData() {
                this.loadingPage = true;
                this.loading = true;
                this.formInline.link_id = this.formInline.link_id.trim();
                getCheckRebateList(this.formInline).then(res => {
                    this.loadingPage = false
                    this.loading = false;
                    if(res.code ==2000) {
                        this.tableData = this.initEditData(res.data);
                        this.pageparm.page = res.page;
                        this.pageparm.limit = res.limit;
                        this.pageparm.total = res.total;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            permissionData(){
                this.getCustomersList();
                if(this.curRole=='admin'){
                    this.getAgentsList();
                    this.getSaleList();
                    this.getPayersList();
                }else if(this.curRole == 'sales'){
                    this.getAgentsList();
                    this.getPayersList();
                }else if(this.curRole == 'agent'){
                    this.getPayersList();
                }
            },
            // 获取伙伴列表
            getAgentsList(){
                getAgentList({company:'',payers:'',sales:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.agentsList = res.data.data;
                    }else{
                        this.$message.error('获取伙伴列表失败！');
                    }
                })
            }, 
            // 获取销售列表
            getSaleList(){
                getSalesList({name:'',phone:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.salesList = res.data.data;
                    }else{
                        this.$message.error('获取销售列表失败！');
                    }
                })
            },
            // 获取客户列表
            getCustomersList(){
                getCustomerList({company:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.customersList = res.data.data;
                    }else{
                        this.$message.error('获取客户列表失败！');
                    }
                })
            },
            // 获取payer列表
            getPayersList(){
                getPayerBasicList({name:'',payer_id:'',region:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.payersList = res.data.data;
                    }else{
                        this.$message.error('获取Payer列表失败！');
                    }
                })
            }, 
            // 如果到了截止日期，显示黄色，如果超过截止日期，显示红色
            tableRowClassName({row,rowIndex}){
                if(row.monthEnd){
                    if(Number(row.monthEnd.toString().substring(0,4)) == this.curYear &&Number(row.monthEnd.toString().substring(4,6)) == this.curMonth){
                        return 'yellow'
                    }else if(Number(row.monthEnd.toString().substring(0,4)) == this.curYear &&Number(row.monthEnd.toString().substring(4,6)) == (this.curMonth - 1)){
                        return 'red'
                    }
                }
            },
            // 状态排序方法（本地排序）
            sortByStatus(a, b) {
                const statusA = this.getStatusInfo(a);
                const statusB = this.getStatusInfo(b);
                return statusA.priority - statusB.priority;
            },
            
            // 排序接口
            sortChange({column,order}){
                if(column.label=='VAP返点'){
                    if(order=='ascending'){
                        this.formInline.orderby = 'discount1';
                    }else if(order=='descending'){
                        this.formInline.orderby = '-discount1';
                    }else{
                        this.formInline.orderby = '';
                    }
                }else{
                    if(order=='ascending'){
                        this.formInline.orderby = 'discount2';
                    }else if(order=='descending'){
                        this.formInline.orderby = '-discount2';
                    }else{
                        this.formInline.orderby = '';
                    }
                }
                this.search()
            },

            // 关闭弹框
            cancel(){
                this.dialogVisible = false;
            },
            edit(row){
                this.formData = {
                    id: row.id,
                    linkId: row.linkId,
                    payerId: row.payerId,
                    entity: row.entity || '',
                    month: row.month || this.formInline.month,
                    discount1: row.discount1 || 0,
                    discount2: row.discount2 || 0,
                    discount3: row.discount3 || 0,
                    sb_discount1: row.sb_discount1 || 0,
                    sb_discount2: row.sb_discount2 || 0,
                    sb_discount3: row.sb_discount3 || 0,
                    credit: row.credit || 0,
                    ri: row.ri || 0,
                    sp: row.sp || 0,
                    bundle: row.bundle || 0,
                    monthEnd: row.monthEnd || 219912
                };
                this.dialogVisible = true;
            },
            submit(){
                this.submitLoading = true;
                updateCheckRebate(this.formData).then(res=>{
                    this.submitLoading = false;
                    if(res.code==2000){
                        this.dialogVisible = false;
                        this.$message.success('屏蔽设置修改成功！');
                        this.getData();
                    }else{
                        this.$message.error('修改失败：' + res.msg);
                    }
                }).catch(err => {
                    this.submitLoading = false;
                    this.$message.error('修改失败：' + err.message);
                })
            },
            search() {
                this.formInline.page = 1
                this.formInline.limit = 20
                this.getData()
                localStorage.setItem('checkRebateForm',JSON.stringify(this.formInline));
            },
            reset(){
                this.formInline = {
                    month:0,
                    region:'',
                    sales:'',
                    agent_id:'',
                    payer_id:'',
                    link_id:'',
                    customer:'',
                    orderby:'',
                    page: 1,
                    limit: 20,
                }
                this.pageparm={
                    page: 1,
                    limit: 20,
                    total: 0
                }
                this.getData()
            },
            callFather(pageInfo) {
                // Element Plus pagination 事件参数处理
                if (typeof pageInfo === 'number') {
                    // @current-change 事件，参数是页码
                    this.formInline.page = pageInfo;
                } else if (typeof pageInfo === 'object' && pageInfo.page) {
                    // 自定义格式
                    this.formInline.page = pageInfo.page;
                    this.formInline.limit = pageInfo.limit;
                }
                this.getData();
            },
            // 处理每页显示数量变化
            handleSizeChange(size) {
                this.formInline.limit = size;
                this.formInline.page = 1; // 重置到第一页
                this.getData();
            },
            // 处理当前页变化
            handleCurrentChange(page) {
                this.formInline.page = page;
                this.getData();
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
                this.tableHeight =  getTableHeight(tabSelectHeight)
            },
        },
        created() {
            this.permissionData();
            let date = new Date();
            //获取当前年份的后一年
            let endY =date.getFullYear();
            //获取当前月
            let endM = (date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1 ) : date.getMonth()+1);
            this.curDate = endY.toString()+endM.toString();
            this.formInline.month = this.curDate;
            if(localStorage.getItem('checkRebateForm')){
                this.formInline = JSON.parse(localStorage.getItem('checkRebateForm'));
            }
            if(this.curRole=='sales'){
                this.formInline.sales = localStorage.getItem('account');
            }else if(this.curRole == 'agent'){
                this.formInline.agent_id = localStorage.getItem('account');
            }
            this.getData()
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },

        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>

<style scoped>
.check-rebate-manage {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0 0 8px 0;
  color: #303133;
}

.page-header p {
  margin: 0;
  color: #909399;
  font-size: 14px;
}

.info-selector {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  align-items: center;
}

.info-selector span {
  font-weight: 500;
  color: #606266;
}

.rebate-tabs {
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tab-content {
  padding: 20px;
}

.toolbar {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
}

.stat-card {
  background: white;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.stat-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.stat-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
}

.stat-icon .el-icon {
  font-size: 18px;
  color: white;
}

.stat-icon.error-icon {
  background: linear-gradient(135deg, #f56565 0%, #e53e3e 100%);
}

.stat-icon.expired-icon {
  background: linear-gradient(135deg, #dd6b20 0%, #c05621 100%);
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.2;
}

.stat-label {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.pagination-container {
  margin-top: 20px;
  padding: 16px 0;
  display: flex;
  justify-content: center;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}

/* 表格编辑样式 */
.editable-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.editable-cell .el-input-number {
  .el-input__wrapper {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    transition: all 0.3s ease;
    
    &:hover {
      border-color: #cbd5e1;
      background: #f1f5f9;
    }
    
    &.is-focus {
      border-color: #3b82f6;
      background: white;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
  }
  
  .el-input__inner {
    text-align: center;
    font-weight: 500;
  }
}

.percent-sign {
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.editable-cell .el-date-editor {
  .el-input__wrapper {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    transition: all 0.3s ease;
    
    &:hover {
      border-color: #cbd5e1;
      background: #f1f5f9;
    }
    
    &.is-focus {
      border-color: #3b82f6;
      background: white;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
  }
}

/* 表格行样式优化 */
.el-table {
  .el-table__row {
    &:hover {
      background-color: #f8fafc;
    }
  }
  
  .el-table__cell {
    padding: 12px 8px;
  }
}

/* 状态标签样式优化 */
.el-tag {
  font-weight: 500;
  border-radius: 4px;
}

/* Modern Edit Dialog Styles */
.modern-edit-dialog {
    :deep(.el-dialog) {
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    }

    :deep(.el-dialog__header) {
        margin: 0;
        padding: 0;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }
    
    .dialog-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 20px 24px;
        color: white;
        
        .header-icon {
            background: rgba(255, 255, 255, 0.2);
            padding: 8px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            
            .el-icon {
                font-size: 20px;
                color: white;
            }
        }
        
        .dialog-title {
            margin: 0;
            font-size: 18px;
            font-weight: 600;
            color: white;
            
            .dialog-subtitle {
                font-size: 14px;
                opacity: 0.9;
                font-weight: normal;
                margin-left: 8px;
            }
        }
    }

    :deep(.el-dialog__body) {
        padding: 24px;
        background: #f8fafc;
    }

    .dialog-content {
        .form-section {
            background: white;
            border-radius: 8px;
            padding: 20px;
            margin-bottom: 20px;
            border: 1px solid #e4e7ed;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

            &:last-child {
                margin-bottom: 0;
            }

            .section-title {
                display: flex;
                align-items: center;
                gap: 8px;
                margin: 0 0 20px 0;
                color: #303133;
                font-size: 16px;
                font-weight: 600;
                padding-bottom: 12px;
                border-bottom: 2px solid #e4e7ed;
                
                .el-icon {
                    color: #667eea;
                }
            }

            .setting-info {
                margin-bottom: 20px;
                
                :deep(.el-alert) {
                    border-radius: 8px;
                    border: none;
                    background: #f0f4ff;
                }
            }

            .edit-form {
                :deep(.el-form-item) {
                    margin-bottom: 16px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }

                :deep(.el-form-item__label) {
                    font-weight: 500;
                    color: #374151;
                }

                .setting-radio {
                    :deep(.el-radio) {
                        margin-right: 20px;
                        
                        .el-radio__input.is-checked .el-radio__inner {
                            background-color: #667eea;
                            border-color: #667eea;
                        }
                        
                        .el-radio__label {
                            font-weight: 500;
                        }
                    }
                }
            }
        }
    }

    :deep(.el-dialog__footer) {
        background: white;
        padding: 20px 24px;
        border-top: 1px solid #e5e7eb;
    }

    .dialog-footer {
        .footer-note {
            margin-bottom: 20px;
            
            :deep(.el-alert) {
                border-radius: 8px;
            }
        }

        .footer-actions {
            display: flex;
            justify-content: flex-end;
            gap: 12px;

            :deep(.el-button) {
                border-radius: 8px;
                padding: 10px 24px;
                font-weight: 500;
                min-width: 100px;
                
                &.el-button--primary {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    border: none;
                    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
                    
                    &:hover {
                        transform: translateY(-1px);
                        box-shadow: 0 4px 16px rgba(102, 126, 234, 0.4);
                    }
                    
                    &:active {
                        transform: translateY(0);
                    }
                }
                
                &:not(.el-button--primary) {
                    border: 1px solid #d1d5db;
                    background: white;
                    color: #374151;
                    
                    &:hover {
                        border-color: #9ca3af;
                        background: #f9fafb;
                    }
                }
            }
        }
    }
}
</style>